define([
    "./tollModule",
    "./tollService",
    "./tollServiceUrl"
], function () {
});